<script lang="ts">
	import { format } from 'svelte-i18n';

	import { Label } from '@Shelly/shelly-design-system';

	export let isAI = false;
	export let isNew = false;
	export let betaFlag = false;
	export let comingSoon = false;
	export let isNotPremiumOnly = false;
</script>

{#if betaFlag || comingSoon || isAI || isNew}
	<div class="d-flex align-items-center gap-xs">
		{#if betaFlag}
			<Label type="secondary" value="BETA" size="s" />
		{:else if comingSoon}
			<Label
				type="secondary"
				value={$format('label_premium_coming_soon', {
					default: 'Coming Soon',
				})}
				size="s"
			/>
		{/if}
		{#if isAI}
			<Label
				size="xs"
				type="ai"
				value={$format('label_ai', { default: 'ai' }).toUpperCase()}
				icon="fak fa-solid-sparkles"
				iconColor="#0a0a0a"
			/>
		{/if}
		{#if isNew}
			<Label
				{...!isNotPremiumOnly ? { icon: 'fa-solid fa-gem' } : {}}
				type={isNotPremiumOnly ? 'secondary' : 'premium'}
				size="xs"
				value={$format('label_premium_new', {
					default: 'New',
				}).toUpperCase()}
			/>
		{/if}
	</div>
{/if}
